/**
 * Arrays the API uses as fixed positional tuples. The spec names the slots in
 * prose only (see `rightToCureBuffer` in `loan-types.yml`), so the names are
 * transcribed here. Adding a slot upstream is a breaking change for every
 * consumer, so this cannot drift quietly.
 *
 * Keyed by field path. Only add an entry where position carries meaning that
 * the value cannot convey on its own — a min/max pair like `aprVariableRange`
 * reads better unlabelled.
 */
const TUPLE_FIELDS: { [fieldPath: string]: Array<string> } = {
  'terms.rightToCureBuffer': [
    'state',
    'country',
    'templateSubject',
    'mailType',
    'trigger',
    'bufferDays',
  ],
}

export const getTupleFields = (
  fieldPath: string | undefined,
): Array<string> | undefined =>
  fieldPath == null ? undefined : TUPLE_FIELDS[fieldPath]

/** Pairs a tuple with its names, so it can render as an ordinary record. */
export const tupleToRecord = (
  tuple: Array<unknown>,
  fields: Array<string>,
): { [key: string]: unknown } =>
  Object.fromEntries(fields.map((field, idx) => [field, tuple[idx]]))
